import React from 'react';
import './Skeleton.css';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = '1em',
  borderRadius = '4px',
  className = '',
}) => {
  return (
    <div
      className={`skeleton ${className}`}
      style={{ width, height, borderRadius }}
    />
  );
};

/** Скелетон карточки участка на дашборде */
export const SkeletonCard: React.FC = () => {
  return (
    <article className="skeleton-card" aria-hidden="true">
      <header className="skeleton-card__header">
        <Skeleton width="58%" height="16px" borderRadius="6px" />
        <Skeleton width="28px" height="28px" borderRadius="8px" className="skeleton-card__menu" />
      </header>

      <div className="skeleton-card__stats">
        <Skeleton width="42%" height="12px" borderRadius="4px" />
        <Skeleton width="68%" height="12px" borderRadius="4px" />
      </div>

      <Skeleton width="100%" height="38px" borderRadius="8px" className="skeleton-card__button" />
    </article>
  );
};
